import axios from "axios";
import Vue from "vue";

const state = {
  user: null,
  token: null,
};

const getters = {
  //isAuthenticated: (state) => !!state.token,
  User: (state) => state.user,
  //Token: (state) => state.token,
};

const actions = {
  // LogIn
  async LogIn({ commit }, payload) {
    return await axios.post(`${process.env.VUE_APP_APIURL}auth/signin`, {
      idToken: payload.idToken
    }).then((response) => {
        commit("setUser", response.data.user);
        //commit("setToken", response.data.accessToken);
        localStorage.setItem(Vue.Keys.TOKEN, response.data.accessToken);
        return true;
    })
    .catch((error) => {
        console.log(error);
        return false;
    });
  },

  // LogOut
  async LogOut({ commit }) {
    commit("logout");
  }
}

const mutations = {
  setUser(state, email) {
      state.user = email;
  },

  // setToken(state, token) {
  //     state.token = token;
  // },

  logout(state) {
      state.user = null;
      //state.token = null;
      let lan = localStorage.getItem(Vue.Keys.LANGUAGE);
      localStorage.clear();
      localStorage.setItem(Vue.Keys.LANGUAGE, lan);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
